import { styled, Row } from '@tools/wr-catalog-base'

export const ProductBodyControlsContainer = styled.div`
  .learn-more {
    padding-top: 0.35rem;
    text-decoration: underline;
    text-transform: uppercase;
    color: #ffffff;
    cursor: pointer;
    align-self: center;
  }

  button {
    min-width: 125px;
    min-height: 33px;
    font-size: 0.95rem !important;
    background: #fff !important;
    border: 1px solid #3d4647 !important;
    color: #3d4647 !important;
    margin-left: auto;
    display: block;

    img {
      position: absolute;
      top: -6px;
      left: -6px;
      &.white {
        color: white;
      }
      &.red {
        color: red;
      }
    }
  }
`
export const ProductTypeLabel = styled.span`
  position: absolute;
  bottom: 15px;
  left: 20px;
  font-size: 19px;
  font-weight: 700;
`

export const ProductCardDescription = styled.p`
  display: block;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  max-height: 3.3em;
  line-height: 1.1em;
  font-weight: 600;
  margin-top: 12px;

  & * {
    font-weight: inherit;
  }
`

export const ModalHeader = styled(Row)`
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;

    svg {
      margin-right: 7px;
    }
  }
`

export const ModalBody = styled(Row)`
  font-size: 13px;

  h3 {
    margin-bottom: 7px;
    font-size: 15px;
    color: #68c251;
    cursor: pointer;
  }
`
